<div class="row">
    <div class="row">
        <button class="btn btn-info btn" style="float: right;margin-right: 1.5%;" (click)="ExportDSCard(false)" [disabled] ="!DSCardDataToExport || convertingPDFSpin">Export Excel</button>
        <button class="btn btn-info btn" style="float: right;margin-right: 0.5%;" (click)="ExportDSCard(true)" [disabled]="!DSCardDataToExport || convertingPDFSpin"
         matTooltip="The conversion could take up to 13s"
         matTooltipPosition = "left"
         matTooltipClass="export-tooltip">
            <i class="fa fa-spinner fa-spin " *ngIf="convertingPDFSpin"></i> Export PDF
        </button>
    </div>

    <div class="col-md-6">
    <label style="color:white;">Speeding Trending</label> 
        <div class="table-responsive dashtable">
            <table id = 'speedingTrend' mat-table [dataSource] = "speedingTrendTblDataSource" #sortSpeedingTrend ='matSort' matSort  class="table table-condensed table-striped">
                <ng-container matColumnDef="YearMonth">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Month
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.YearMonth.toString().slice(4) + '-' + element.YearMonth.toString().slice(0, 4)   }}
                     </td>
                </ng-container>
                
                <ng-container matColumnDef="derived_Under5" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Under 5
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.Sum_MovingTime_Hr == 0 ? 0 : (element.SpeedingTrend_Under_5_ByTime / 3600 * 100 / element.Sum_MovingTime_Hr) | number: '1.01-1' }}%
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="derived_5To10" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        5 To 10
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.Sum_MovingTime_Hr == 0 ? 0 : (element.SpeedingTrend_5_10_ByTime / 3600 * 100 / element.Sum_MovingTime_Hr) | number: '1.01-1' }}%
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="derived_10To15" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        10 To 15
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.Sum_MovingTime_Hr == 0 ? 0 : (element.SpeedingTrend_10_15_ByTime /3600 * 100 / element.Sum_MovingTime_Hr) | number: '1.01-1' }}%
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="derived_Over15" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Over 15
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.Sum_MovingTime_Hr == 0 ? 0 : (element.SpeedingTrend_Over_15_ByTime / 3600 * 100 / element.Sum_MovingTime_Hr) | number: '1.01-1' }}% 
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="speedingTrendColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: speedingTrendColumns;"></tr>
            </table>
            


        </div>

    </div>
    <div id ="trendChartDv" class="col-md-6" *ngIf ='DSCardTrendingChartData.length > 0'>
        <h5 style="font-weight:bold;margin-top: 1%;">Speeding Trending Data</h5>
        <!-- <nvd3 options="driverScoreCardLineOptions" data="driverScoreCardTrendChartData"> </nvd3> -->

        <canvas baseChart id="trendingLinechart" 
        [datasets]="DSCardTrendingChartData" 
        [colors]="DSCardTrendingChartColors" 
        [options]="DSCardTrendingChartOptions" 
        [labels]="DSCardTrendingChartlabels"
        [chartType] = 'DSSpeedingTrendChartType'></canvas>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
    <label style="color:white;">Company Comparison - {{DSCardComparisonChartData?.length > 0 ? dashMonthCompareDisplay?.toString().slice(4) + '/' + dashMonthCompareDisplay?.toString().slice(0, 4) : ''}}</label> 
        <div class="row" style="margin-top: -1%;" [hidden]= "!(DSCardComparisonChartData.length > 0)">
            <div class="col-md-3" id = "DSCardPRDropDownDv" style="float:right;">
                <select class="form-control" [(ngModel)]="DSCardCompanyProgramDr" style="height:auto;" (change)="DSCardProgramDrChange(DSCardCompanyProgramDr)">
                    <option >{{dashboardCompanyProgram}}</option>
                    <option value = 2>All Programs</option>
                </select>
            </div>
        </div>
        
        <div class="table-responsive dashtable">
            <table id = 'speedingComparison' mat-table [dataSource] = "speedingComparisonTblDataSource"  class="table table-condensed table-striped">
                <ng-container matColumnDef="categories">
                    <th mat-header-cell *matHeaderCellDef>
                        Categories
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.categories  }}
                     </td>
                </ng-container>
                
                <ng-container matColumnDef="derived_Under5">
                    <th mat-header-cell *matHeaderCellDef>
                        Under 5
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_MovingTime_Hr == 0 ? 0 : (element.sum_Speeding_Under_5mph_ByTime / 3600 * 100 / element.sum_MovingTime_Hr) | number: '1.01-1' }}%
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="derived_5To10">
                    <th mat-header-cell *matHeaderCellDef>
                        5 To 10
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_MovingTime_Hr == 0 ? 0 : (element.sum_Speeding_5_10mph_ByTime / 3600 * 100 / element.sum_MovingTime_Hr) | number: '1.01-1' }}%
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="derived_10To15">
                    <th mat-header-cell *matHeaderCellDef>
                        10 To 15
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_MovingTime_Hr == 0 ? 0 : (element.sum_Speeding_10_15mph_ByTime /3600 * 100 / element.sum_MovingTime_Hr) | number: '1.01-1' }}%
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="derived_Over15">
                    <th mat-header-cell *matHeaderCellDef>
                        Over 15
                    </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{ element.sum_MovingTime_Hr == 0 ? 0 : (element.sum_Speeding_Over_15mph_ByTime / 3600 * 100 / element.sum_MovingTime_Hr) | number: '1.01-1' }}% 
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="speedingComparisonColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: speedingComparisonColumns;" style="height:0px;"></tr>
            </table>
            

            

        </div>
    </div>
    <div id = "comparisonChartdDv" class="col-md-6" *ngIf= "DSCardComparisonChartData.length > 0">
        <h5 style="font-weight:bold;margin-top: 1%;margin-left: 0%">Your Company Compared to eCaptiv {{ (DSCardCompanyProgramDr != 2 ? dashboardCompanyProgram : 'All Programs') + ' - ' + dashMonthCompareDisplay?.toString().slice(4) + '/' + dashMonthCompareDisplay?.toString().slice(0,4) }}</h5>
        <!-- <nvd3 options="driverScoreCardComparisonLineOptions" data="driverScoreCardComparisonChartData"> </nvd3> -->
        <!--<canvas id="comparisonLinechart" class="chart chart-line" chart-data="DSCardComparisonChartData" chart-colors="DSCardComparisonChartColors" chart-options="DSCardComparisonChartOptions" chart-labels="DSCardComparisonChartlabels" chart-series= "DSCardComparisonSeries"></canvas>-->

        <canvas baseChart id="comparisonLinechart" 
        [datasets]="DSCardComparisonChartData" 
        [colors]="DSCardComparisonChartColors" 
        [options]="DSCardComparisonChartOptions" 
        [labels]="DSCardComparisonChartlabels"
        [chartType] = 'DSCardComparisonChartType'></canvas>
    </div>
</div>


<div class="row" *ngIf="comparisonXShow">
    <div id = comparisonXChartdDv class="col-md-6" >
        <!--<canvas id="comparisonXLinechart" class="chart chart-line" chart-data="DSCardComparisonXChartData" chart-colors="DSCardComparisonChartColors" chart-options="DSCardComparisonChartOptions" chart-labels="DSCardComparisonChartlabels" chart-series= "DSCardComparisonXSeries"></canvas>-->

        <canvas baseChart id="comparisonXLinechart" 
        [datasets]="DSCardComparisonXChartData" 
        [colors]="DSCardComparisonChartColors" 
        [options]="DSCardComparisonChartOptions" 
        [labels]="DSCardComparisonChartlabels"
        [chartType] = 'DSCardComparisonChartType'></canvas>
    </div>
</div>

<!-- safety event -->
<div class="row">
    <div class="col-md-6">
        <label style="color:white;">Total Safety Events Trending</label> 
            <div class="table-responsive dashtable">
                <table id = 'safetEventTrend' mat-table [dataSource] = "safetEventTrendTblDataSource" #sortSafetEventTrend ='matSort' matSort  class="table table-condensed table-striped">
                    <ng-container matColumnDef="YearMonth">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Month
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.YearMonth.toString().slice(4) + '-' + element.YearMonth.toString().slice(0, 4)   }}
                         </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="TotalNumberOfEvents" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Total Events
                        </th>
                        <td mat-cell *matCellDef="let element"> 
                            {{ element.TotalNumberOfEvents }}
                        </td>
                    </ng-container>
    
                    
    
                    <tr mat-header-row *matHeaderRowDef="safetEventTrendColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: safetEventTrendColumns;" ></tr>
                </table>
                
    
    
            </div>
    
    </div>
    
    <div id ="safetEventTrendChartDv" class="col-md-6" *ngIf ='DSCardSafetyEventTrendingChartData.length > 0'>
        <h5 style="font-weight:bold;margin-top: 1%;">Total Safety Events Trending</h5>
        <canvas baseChart id="safetyEventTrendingLinechart" 
        [datasets]="DSCardSafetyEventTrendingChartData" 
        [colors]="DSCardSafetyEventTrendingChartColors" 
        [options]="DSCardSafetyEventTrendingChartOptions" 
        [labels]="DSCardSafetyEventTrendingChartlabels"
        [chartType] ="DSSafetyEventTrendingChartType"></canvas>
    </div>
</div>

<div class="row">
    <div class="col-md-6">
        <label style="color:white;">Total Safety Events Trending by Category</label> 
        <div class="table-responsive dashtable">
            <table id = 'safetEventCategoriesTrend' mat-table [dataSource] = "safetEventCategoriesTblDataSource" #sortSafetEvenCategoriesTrend ='matSort' matSort  class="table table-condensed table-striped">
                <ng-container *ngFor="let column of safetEventCategoriesTrendColumns" matColumnDef="{{column}}">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{column}}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ column === 'Month' ? (element.YearMonth.toString().slice(4) + '-' + element.YearMonth.toString().slice(0, 4)) : element[column] }}
                        
                        </td>
                </ng-container>
                
             
                <tr mat-header-row *matHeaderRowDef="safetEventCategoriesTrendColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: safetEventCategoriesTrendColumns;"></tr>
            </table>
        </div>
    </div>
    <div id ="safetEventCategoriesTrendChartDv" class="col-md-6" *ngIf ='DSCardSafetyEventCategoriesTrendingChartData.length > 0'>
        <h5 style="font-weight:bold;margin-top: 1%;">Total Safety Events Trending by Category</h5>
        <canvas baseChart id="safetyEventCategoriesTrendingLinechart" 
        [datasets]="DSCardSafetyEventCategoriesTrendingChartData" 
        [colors]="DSCardSafetyEventCategoriesTrendingChartColors" 
        [options]="DSCardSafetyEventCategoriesTrendingChartOptions" 
        [labels]="DSCardSafetyEventCategoriesTrendingChartlabels"
        [chartType] ="DSSafetyEventCategoriesTrendingChartType"></canvas>
    </div>
</div>
